import {translate} from "../../utils/Common"
import Spinner from "../Spinner";
const ItemsInfo = (props) => {
    return ( (props.itemName === translate("global.packages")  ||  props.itemName === translate("global.lockers") || props.itemName === translate("sidebar.options.packages.alerted") ) &&
      (
        props.isLoading ? (
            <div className="text-left mb-2">
                <Spinner type={1} /> 
                <span className="ml-2">
                   {translate("global.searchingPackages")} ...
                </span>
            </div>
        ) : (
            <div className="text-left mb-2">
                <span>
                    {translate("global.haveBeenFound")} <span className="font-semibold">{ props.cantItemsFound }</span> { props.itemName.toLowerCase() } {translate("global.parametersEntered")}
                </span>
            </div>
        )
    )
    )
}

export default ItemsInfo;